/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputEnableTwoFactorRequest
 */
export interface InputEnableTwoFactorRequest {
    /**
     * 
     * @type {string}
     * @memberof InputEnableTwoFactorRequest
     */
    credential?: string;
    /**
     * 
     * @type {string}
     * @memberof InputEnableTwoFactorRequest
     */
    method: InputEnableTwoFactorRequestMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof InputEnableTwoFactorRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof InputEnableTwoFactorRequest
     */
    totpCode?: string;
    /**
     * 
     * @type {string}
     * @memberof InputEnableTwoFactorRequest
     */
    totpSecret?: string;
}


/**
 * @export
 */
export const InputEnableTwoFactorRequestMethodEnum = {
    Webauthn: 'webauthn',
    Totp: 'totp'
} as const;
export type InputEnableTwoFactorRequestMethodEnum = typeof InputEnableTwoFactorRequestMethodEnum[keyof typeof InputEnableTwoFactorRequestMethodEnum];


/**
 * Check if a given object implements the InputEnableTwoFactorRequest interface.
 */
export function instanceOfInputEnableTwoFactorRequest(value: object): boolean {
    if (!('method' in value)) return false;
    return true;
}

export function InputEnableTwoFactorRequestFromJSON(json: any): InputEnableTwoFactorRequest {
    return InputEnableTwoFactorRequestFromJSONTyped(json, false);
}

export function InputEnableTwoFactorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputEnableTwoFactorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'credential': json['credential'] == null ? undefined : json['credential'],
        'method': json['method'],
        'name': json['name'] == null ? undefined : json['name'],
        'totpCode': json['totpCode'] == null ? undefined : json['totpCode'],
        'totpSecret': json['totpSecret'] == null ? undefined : json['totpSecret'],
    };
}

export function InputEnableTwoFactorRequestToJSON(value?: InputEnableTwoFactorRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credential': value['credential'],
        'method': value['method'],
        'name': value['name'],
        'totpCode': value['totpCode'],
        'totpSecret': value['totpSecret'],
    };
}

